import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, finalize, switchMap, throwError } from 'rxjs';
import { UserService } from '../services/user.service';
import { FuseLoadingService } from '../services/loading/loading.service';
import { SERVER_URL } from 'src/environments/environment';
import { StorageService } from '../services/storage.service';
import { Router } from '@angular/router';
import { ToolsService } from '../services/tools.service';
import { PUBLIC_LOGIN_REQUEST } from './auth-context';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  constructor(
    private authService: UserService,
    private storageService: StorageService,
    private router: Router,
    private toolService: ToolsService,
    private fuseLoadingService: FuseLoadingService,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    req = req.clone({
      withCredentials: true,
    });

    return next.handle(req).pipe(
      catchError((error) => {
        if (req.context.get(PUBLIC_LOGIN_REQUEST) || req.url.includes('/auth/refresh')) {
          return throwError(() => error);
        }
        if (
          error instanceof HttpErrorResponse &&
          !req.url.includes('/auth/login/admin') &&
          error.status === 401
        ) {
          return this.handle401Error(req, next, error);
        } else if (error.status == 422) {
          if (req.url.includes('invitation')) {
            return throwError(() => error);
          } else {
            this.navigateToLogin();
          }
        }

        return throwError(() => error);
      }),
    );
  }

  private navigateToLogin() {
    const path = this.router.url.split(/[?#]/)[0];
    if (path !== '/login' && !path.startsWith('/login/')) {
      void this.router.navigate(['/login']);
    }
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
    if (!this.storageService.isLoggedIn()) {
      return throwError(() => error);
    }
    if (!this.isRefreshing) {
      this.isRefreshing = true;

      if (this.storageService.isLoggedIn()) {
        return this.authService.refreshToken().pipe(
          switchMap((newToken) => {
            this.isRefreshing = false;
            this.storageService.saveRefreshToken(newToken['refresh_token']);
            this.storageService.saveToken(newToken['access_token']);
            // Clone the request with the new token
            const newRequest = request.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken['access_token']}`,
              },
            });
            // Retry the request with the new token
            return next.handle(newRequest);
          }),
          catchError((error) => {
            this.fuseLoadingService._setLoadingStatus(false, request.url);
            this.isRefreshing = false;
            this.authService.logout();
            this.navigateToLogin();

            this.toolService.presentErrorToast(
              'Sesión cerrada por vencimiento del token de actualización. Por favor, inicie sesión nuevamente.',
            );
            return throwError(() => error);
          }),
        );
      }
    }

    return next.handle(request);
  }
}

export const selectedMallInterceptor: HttpInterceptorFn = (req, next) => {
  let userService = inject(UserService);
  const fuseLoadingService = inject(FuseLoadingService);

  const urlParts = req.url.split('/');
  const url = `${urlParts[0]}//${urlParts[2]}`;

  let sessionToken = window.localStorage.getItem('token');
  const hasAuthorizationHeader = req.headers.has('Authorization');

  if (
    !req.context.get(PUBLIC_LOGIN_REQUEST) &&
    !!sessionToken &&
    !hasAuthorizationHeader &&
    !req.url.includes('auth/refresh') &&
    !req.url.includes('login/admin') &&
    !req.url.includes('megaincentivos.com') &&
    !req.url.includes('profile/fields') &&
    !req.url.includes('crm/profile/') &&
    !req.url.includes('horus/crm/profile/contact-validation-alert') &&
    !req.url.includes('/horus/crm/answers/update') &&
    !req.url.includes('/horus/crm/questions/featured/answers') &&
    !req.url.includes('/thoth/bills/user-bills-by-campaign') &&
    !req.url.includes('bills/create') &&
    !req.url.includes('assign/channel/admin') &&
    !req.url.includes('campaigns/tickets') &&
    !req.url.includes('amazonaws.com') &&
    !req.url.includes('amazonaws.com/process') &&
    !req.url.includes('answers/create') &&
    !req.url.includes('campaigns/active') &&
    !req.url.includes('campaigns/recalculate-tickets') &&
    !req.url.includes('roles-and-levels') &&
    !req.url.includes('anubis/auth/user') &&
    !req.url.includes('/thoth/campaigns/update-data-fields') &&
    !req.url.includes('/horus/crm/profile')&&
    !req.url.includes('/anubis/auth/password/reset')&&
    !req.url.includes('/thoth/bills/json-upload/complete')&&
    !req.url.includes('/horus/crm/vehicles/')
  ) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
  }

  if (url == SERVER_URL) {
    req = req.clone({
      setHeaders: {
        Authorization: `token 40550739b20f840e2085cbf831c0057911bbc38d`,
      },
    });
  }
  let additionalParams: any = {};
  if (userService.currentMall) {
    //additionalParams['mall'] = userService.currentMall.id;
  }

  // Set the loading status to true
  fuseLoadingService._setLoadingStatus(true, req.url);
  console.debug('selectedMallInterceptor additionalParams', additionalParams);

  return next(req.clone({ setParams: additionalParams })).pipe(
    finalize(() => {
      // Set the status to false if there are any errors or the request is completed
      fuseLoadingService._setLoadingStatus(false, req.url);
    }),
  );
};
